/**
 * Clear a string of all non-numeric characters
 * @thanks https://stackoverflow.com/a/1183922/7252759
 */
export const extractDigits = (str: string) => str.replace(/\D/g, '');
